var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_153_1485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.853595 19.7606C0.852657 23.1214 1.73766 26.403 3.42047 29.2954L0.692657 39.1778L10.8852 36.5261C13.7043 38.0489 16.8629 38.8468 20.0727 38.847H20.0811C30.6772 38.847 39.3027 30.2915 39.3072 19.7757C39.3092 14.68 37.3111 9.88839 33.6808 6.28342C30.0511 2.67877 25.2238 0.692572 20.0803 0.690247C9.48297 0.690247 0.85797 9.24529 0.853595 19.7606Z",
    fill: "url(#paint0_linear_153_1485)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.167188 19.7544C0.166094 23.2361 1.08281 26.635 2.82562 29.631L0 39.8678L10.558 37.1209C13.467 38.6947 16.7423 39.5245 20.0752 39.5257H20.0837C31.06 39.5257 39.9953 30.6625 40 19.7702C40.0019 14.4915 37.9319 9.5276 34.1719 5.79349C30.4114 2.05984 25.4114 0.00217054 20.0837 0C9.10562 0 0.171719 8.86202 0.167344 19.7544H0.167188ZM6.45469 29.115L6.06047 28.4941C4.40328 25.8795 3.52859 22.8581 3.52984 19.7557C3.53344 10.7022 10.9591 3.33643 20.09 3.33643C24.5119 3.33829 28.6675 5.04868 31.7931 8.15194C34.9186 11.2555 36.6384 15.3811 36.6373 19.769C36.6333 28.8225 29.2075 36.1891 20.0837 36.1891H20.0772C17.1064 36.1876 14.1928 35.396 11.6519 33.9L11.0472 33.5442L4.78188 35.1741L6.45469 29.1149V29.115Z",
    fill: "url(#paint1_linear_153_1485)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1059 11.4958C14.7331 10.6736 14.3408 10.657 13.9862 10.6426C13.6959 10.6302 13.3641 10.6311 13.0325 10.6311C12.7006 10.6311 12.1614 10.755 11.7056 11.2488C11.2494 11.7431 9.96375 12.9375 9.96375 15.3668C9.96375 17.7963 11.747 20.144 11.9956 20.4738C12.2445 20.8029 15.4383 25.9477 20.4964 27.927C24.7002 29.5718 25.5556 29.2446 26.468 29.1622C27.3805 29.08 29.4123 27.968 29.8269 26.815C30.2417 25.6622 30.2417 24.6739 30.1173 24.4674C29.993 24.2617 29.6611 24.1381 29.1634 23.8913C28.6656 23.6443 26.2191 22.4498 25.763 22.2849C25.3067 22.1203 24.975 22.0381 24.6431 22.5325C24.3112 23.0262 23.3583 24.1381 23.0678 24.4674C22.7777 24.7975 22.4872 24.8386 21.9897 24.5916C21.4917 24.3439 19.8891 23.8231 17.9877 22.1411C16.5083 20.8322 15.5095 19.216 15.2192 18.7215C14.9289 18.2279 15.1881 17.9603 15.4377 17.7143C15.6612 17.493 15.9355 17.1377 16.1845 16.8494C16.4327 16.5611 16.5155 16.3553 16.6814 16.026C16.8475 15.6964 16.7644 15.408 16.6402 15.1611C16.5155 14.9141 15.5484 12.4721 15.1059 11.4958Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_153_1485",
    x1: 19.9999,
    y1: 39.1778,
    x2: 19.9999,
    y2: 0.690247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_153_1485",
    x1: 20,
    y1: 39.8678,
    x2: 20,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_153_1485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.afe01275a40c8877673ed945cf32df90.svg";
export { ForwardRef as ReactComponent };